(function () {
  // Helpers
  const $ = (sel, root=document) => root.querySelector(sel);
  const $$ = (sel, root=document) => Array.from(root.querySelectorAll(sel));
  const parseJSON = el => { try { return JSON.parse(el.textContent); } catch { return null; } };

  function scopeProduct(el){
    return el.closest('section, form[action^="/cart/add"], .product, .product__info, .product-view, .product-section') || document;
  }

  function getProductJSON(ctx){
    let s = $('script[type="application/json"][data-product]', ctx)
          || $('script[type="application/json"][id^="ProductJson-"]', ctx)
          || $('script[type="application/json"][data-product]', document);
    return s ? parseJSON(s) : null;
  }

  function currentVariant(ctx){
    const idEl = $('form[action^="/cart/add"] input[name="id"]', ctx);
    const id = idEl && idEl.value ? String(idEl.value) : null;
    if (!id) return null;
    const data = getProductJSON(ctx);
    if (data && Array.isArray(data.variants)) {
      const v = data.variants.find(v => String(v.id) === id);
      if (v) return v;
    }
    return findVariantById(id);
  }

  function setMoney(el, formattedHtml){
    if (!el) return;
    el.innerHTML = formattedHtml;
  }

  function getMetaobjectForVariant(root, scope, variantId){
    const key = String(variantId);

    for (const mapEl of document.querySelectorAll('.planet-price-payloads')) {
      try {
        const map = JSON.parse(mapEl.textContent);
        if (key in map) return map[key] ?? null;
      } catch {}
    }

    const payloadEl = root.querySelector('.planet-price-payload')
                  || (scope || document).querySelector('.planet-price-payload');
    try {
      const p = payloadEl ? JSON.parse(payloadEl.textContent) : null;
      if (p && String(p.variant?.id) === String(variantId)) return p.metaobjectVariant;
    } catch {}
    return null;
  }

  window.__planet = window.__planet || {};
  window.__planet.getMetaobjectForVariant = getMetaobjectForVariant;

  function ensureSaleBlock(root) {
    const container = root.querySelector('.price__container') || root;
    const labelR = container.getAttribute('data-label-price-regular') || 'Precio regular';
    const labelS = container.getAttribute('data-label-price-sale') || 'Precio de oferta';
    const regular = root.querySelector('.price__regular');
    if (regular) regular.style.display = 'none';

    let sale = root.querySelector('.price__sale');
    if (!sale) {
      sale = document.createElement('div');
      sale.className = 'price__sale';
      container.appendChild(sale);
    }
    const hasS = !!sale.querySelector('s');
    const hasIns = !!sale.querySelector('ins');
    if (!hasS || !hasIns) {
      sale.innerHTML = `
        <div class="price__sale-inner">
          <span class="visually-hidden">${labelR}</span>
          <s class="js-price-compare"><span class="money"></span></s>
          <span class="visually-hidden">${labelS}</span>
          <ins class="js-price-current js-price-current-sale"><span class="money"></span></ins>
        </div>
      `;
    }

    return {
      compareEl: sale.querySelector('.js-price-compare') || sale.querySelector('s'),
      currentEl: sale.querySelector('.js-price-current-sale') || sale.querySelector('ins, .js-price-current')
    };
  }

  function findVariantById(id){
    const key = String(id);
    const sels = 'script[type="application/json"].planet-variants-json, script[type="application/json"][data-product-variants-json], script[type="application/json"][data-product], script[type="application/json"][id^="ProductJson-"]';
    for (const el of document.querySelectorAll(sels)) {
      const data = parseJSON(el);
      const arr = Array.isArray(data) ? data : (data && Array.isArray(data.variants) ? data.variants : null);
      if (!arr) continue;
      const v = arr.find(v => String(v.id) === key);
      if (v) return v;
    }
    return null;
  }

  function applyInRoot(root){
    if (!root) return;

    const payloadEl = $('.planet-price-payload', root);
    const payload = payloadEl ? (parseJSON(payloadEl) || {}) : {};
    const ctx = scopeProduct(root);

    
    const vNow = currentVariant(ctx);
    let variant = vNow || payload.variant || variantFromDataAttr(root, ctx);
    if (!variant) return;

    if (typeof variant.price !== 'number') {
      const full = findVariantById(variant.id);
      if (full) variant = full;
    }
    if (typeof variant.price !== 'number') return; // sin datos no se puede calcular

    const metaobjectVariant = getMetaobjectForVariant(root, ctx, variant.id);
    const fn = window.PlanetDataset && window.PlanetDataset.getDiscountForVariant;
    if (typeof fn !== 'function') return;

    const prices = fn(variant, metaobjectVariant);
    if (!prices) return;

    const hasDeal = (typeof prices.discount === 'number' && prices.discount > 0)
                 || (typeof prices.compareAtPrice === 'number' && typeof prices.price === 'number' && prices.compareAtPrice > prices.price);

    if (!hasDeal) {
      if (window.__planet?.removeBadge) window.__planet.removeBadge(root);
      return;
    }

    const signature = String(prices.priceFormated) + '|' + String(prices.compareAtPriceFormated) + '|' + String(variant.id);
    if (root.dataset.planetSig === signature) return;

    const { compareEl, currentEl } = ensureSaleBlock(root);
    setMoney(currentEl, prices.priceFormated);
    setMoney(compareEl, prices.compareAtPriceFormated);
    root.classList.add('price--on-sale');

    if (window.__planet?.upsertBadge) {
      window.__planet.upsertBadge(root, prices);
    }
    root.dataset.planetSig = signature;
  }

  function variantFromDataAttr(root, ctx){
    const id = root.getAttribute('data-variant-id');
    if (!id) return null;
    const data = getProductJSON(ctx);
    if (data && Array.isArray(data.variants)){
      const v = data.variants.find(v => String(v.id) === String(id));
      if (v) return v;
    }
    return { id: Number(id) || id };
  }

  function applyAll(scope){
    $$('.js-price-root', scope || document).forEach(root => {
      if (root.closest('product-card, .product-card')) return;
      applyInRoot(root);
    });
  }

  function whenPlanetReady(cb){
    if (typeof window.PlanetDataset?.getDiscountForVariant === 'function') { cb(); return; }
    let tries = 0, max = 120; // ~36s a 300ms
    const t = setInterval(() => {
      if (typeof window.PlanetDataset?.getDiscountForVariant === 'function') {
        clearInterval(t); cb();
      } else if (++tries >= max) {
        clearInterval(t);
      }
    }, 300);
    document.addEventListener('planet:ready', () => { cb(); }, { once:true });
  }

  // Hooks
  document.addEventListener('DOMContentLoaded', function(){
    ensureProductBadgeStyles();
    whenPlanetReady(() => applyAll(document));
  });

  function reapplyFromEvent(e){
    whenPlanetReady(() => {
      const scope = scopeProduct(e.target instanceof Element ? e.target : document.body);
      applyAll(scope);
    });
  }

  document.addEventListener('variant:change', reapplyFromEvent);
  document.addEventListener('variant-change', reapplyFromEvent);
  document.addEventListener('change', function(e){
    const el = e.target;
    if (el instanceof Element && el.matches('form[action^="/cart/add"] input[name="id"]')) {
      reapplyFromEvent(e);
    }
  });

  let moTimer = null;
  const rootScope = document.body;
  const mo = new MutationObserver(() => {
    if (moTimer) return;
    moTimer = setTimeout(() => { whenPlanetReady(() => applyAll(rootScope)); moTimer = null; }, 50);
  });
  mo.observe(rootScope, { childList: true, subtree: true });

  // === BADGES LOCALIZADOS ===

  function getPlanetBadgeConfig(){
    const el = document.getElementById('planet-badge-config');
    if (!el) return { template: '-__PCT__%', classes: 'product-card__badge product-card__badge--discount' };
    try { return JSON.parse(el.textContent); }
    catch { return { template: '-__PCT__%', classes: 'product-card__badge product-card__badge--discount' }; }
  }
  const _badgeCfg = getPlanetBadgeConfig();

  function formatDiscountBadge(pct){
    return (_badgeCfg.template || '-__PCT__%').replace('__PCT__', String(pct));
  }

  function upsertPlanetBadgeLocalized(root, prices) {
    if (typeof prices.compareAtPrice !== 'number' || typeof prices.price !== 'number') { removePlanetBadge(root); return; }
    const denom = prices.compareAtPrice, numer = denom - prices.price;
    const pct = Math.round((numer / (denom || 1)) * 100);
    if (!isFinite(pct) || pct <= 0) { removePlanetBadge(root); return; }

    const card = root.closest('.product-card, .card-wrapper, .product-grid__item, .product, .product-item, section') || root;

    // contenedor
    let container = card.querySelector('.product-card__badges');
    if (!container) {
      container = document.createElement('span');
      container.className = 'product-card__badges';
      const priceContainer = card.querySelector('.price__container') || root;
      priceContainer.parentNode.insertBefore(container, priceContainer);
    }

    // badge
    let badge = container.querySelector('.planet-badge-discount');
    if (!badge) {
      badge = document.createElement('span');
      badge.className = _badgeCfg.classes + ' planet-badge-discount';
      container.appendChild(badge);
    }

    const formatted = formatDiscountBadge(pct);
    badge.innerHTML = formatted.replace(/(\d+)\s*%/, '<span class="percentage">$1</span>%');
    badge.classList.remove('hidden');
  }

  function ensureProductBadgeStyles() {
    if (document.querySelector('link[data-planet-badge-css]')) return;

    const href = window.__planetBadgeCSS;
    if (!href) return;

    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    link.media = 'print';
    link.onload = () => (link.media = 'all');
    link.setAttribute('data-planet-badge-css', 'true');
    document.head.appendChild(link);

    const vars = window.__planetBadgeVars || {};
    const style = document.createElement('style');
    style.textContent = `
      :root {
        --color-badge-discount-background: ${vars.bg || '#000'};
        --color-badge-discount-foreground: ${vars.fg || '#fff'};
      }
    `;
    document.head.appendChild(style);
  }

  function removePlanetBadge(root){
    const card = root.closest('.product-card, .card-wrapper, .product-grid__item, .product, .product-item, section') || root;
    const badge = card.querySelector('.planet-badge-discount');
    if (badge) badge.classList.add('hidden');
  }

  window.__planet.upsertBadge = upsertPlanetBadgeLocalized;
  window.__planet.removeBadge = removePlanetBadge;
})();


(function(){
  const SEL_CARD = 'product-card, .product-card';

  // Helpers
  const $ = (sel, r=document) => r.querySelector(sel);
  const $$ = (sel, r=document) => Array.from(r.querySelectorAll(sel));
  const setMoney = (el, f) => { if (el) el.innerHTML = f; };

  function ensureSale(root){
    const container = $('.price__container', root) || root;
    const labelR = container?.getAttribute('data-label-price-regular') || 'Regular price';
    const labelS = container?.getAttribute('data-label-price-sale') || 'Sale price';

    const regular = $('.price__regular', root);
    if (regular) regular.style.display = 'none';

    let sale = $('.price__sale', root);
    if (!sale) {
      sale = document.createElement('div');
      sale.className = 'price__sale';
      container.appendChild(sale);
    }
    const hasS = !!sale.querySelector('s');
    const hasIns = !!sale.querySelector('ins');
    if (!hasS || !hasIns) {
      sale.innerHTML = `
        <div class="price__sale-inner">
          <span class="visually-hidden">${labelR}</span>
          <s class="js-price-compare"><span class="money"></span></s>
          <span class="visually-hidden">${labelS}</span>
          <ins class="js-price-current js-price-current-sale"><span class="money"></span></ins>
        </div>`;
    }

    return {
      compareEl: $('.js-price-compare', sale) || $('s', sale),
      currentEl: $('.js-price-current-sale', sale) || $('ins, .js-price-current', sale)
    };
  }

  function getVariantsFromCard(card){
    const s = $('script[type="application/json"][data-product-variants-json], script[type="application/json"][data-product-variants], script[type="application/json"][data-product-variants-json=""]', card);
    if (!s) return [];
    try { return JSON.parse(s.textContent) || []; } catch { return []; }
  }
  function getSelectedOptions(card){
    const sel = n => $(`input[type="radio"][name$="option[${n}]"]:checked`, card)?.value || null;
    return [sel(1), sel(2), sel(3)];
  }
  function getVariantByOptions(card){
    const [o1,o2,o3] = getSelectedOptions(card);
    const arr = getVariantsFromCard(card);
    if (!arr.length) return null;
    return arr.find(v =>
      (o1 ? v.option1 === o1 : true) &&
      (o2 ? v.option2 === o2 : true) &&
      (o3 ? v.option3 === o3 : true)
    ) || null;
  }

  function formatMoney(cents, format){
    const amount = (cents / 100).toFixed(2);
    const [int, dec] = amount.split('.');
    const intSep = int.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return (format || '{{amount}}')
      .replace(/\{\{\s*amount\s*\}\}/, Number(amount).toLocaleString(undefined, {minimumFractionDigits:2}))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, int)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, `${intSep},${dec}`)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, intSep);
  }

  function revertToRegular(root, variant){
    const container = $('.price__container', root) || root;
    const format = container.getAttribute('data-money-format') || '{{amount}}';

    const sale = $('.price__sale', root);
    if (sale) sale.remove();

    let regular = $('.price__regular', root);
    if (!regular) {
      regular = document.createElement('div');
      regular.className = 'price__regular';
      regular.innerHTML = `<span class="js-price-current"></span>`;
      container.appendChild(regular);
    }
    regular.style.display = '';
    const current = $('.js-price-current', regular);
    if (current && typeof variant.price === 'number') {
      current.innerHTML = formatMoney(variant.price, format);
    }
    root.classList.remove('price--on-sale');
    delete root.dataset.planetSig;
  }

  function applyPlanetInRoot(root, variant, card){
    const fn = window.PlanetDataset && window.PlanetDataset.getDiscountForVariant;
    if (typeof fn !== 'function' || !variant) return;

    const metaobjectVariant = window.__planet?.getMetaobjectForVariant
      ? window.__planet.getMetaobjectForVariant(root, card, variant.id)
      : null;

    const prices = metaobjectVariant ? fn(variant, metaobjectVariant) : null;
    const hasDeal = prices && (
      (typeof prices.discount === 'number' && prices.discount > 0) ||
      (typeof prices.compareAtPrice === 'number' && typeof prices.price === 'number' && prices.compareAtPrice > prices.price)
    );

    if (!hasDeal) {
      if (window.__planet?.removeBadge) window.__planet.removeBadge(root);
      revertToRegular(root, variant);
      return;
    }

    const { compareEl, currentEl } = ensureSale(root);
    setMoney(currentEl, prices.priceFormated);
    setMoney(compareEl, prices.compareAtPriceFormated);
    root.classList.add('price--on-sale');
    root.dataset.planetSig = '';

    if (window.__planet?.upsertBadge) {
      try { window.__planet.upsertBadge(root, prices); } catch {}
    }
  }

  function applyPlanetInCard(card){
    const variant = getVariantByOptions(card) || (function(){
      const id = $('input[name="id"]', card)?.value; return id ? { id } : null;
    })();
    if (!variant) return;

    const idEl = $('input[name="id"]', card);
    if (idEl && String(idEl.value) !== String(variant.id)) idEl.value = String(variant.id);

    $$('.js-price-root', card).forEach(root => {
      root.setAttribute('data-variant-id', String(variant.id));
      applyPlanetInRoot(root, variant, card);
    });
  }

  const pending = new WeakMap();
  function scheduleApply(card){
    if (!card || pending.get(card)) return;
    pending.set(card, true);
    requestAnimationFrame(() => { pending.delete(card); applyPlanetInCard(card); });
  }

  function wireCard(card){
    if (!card || card.__planetCardWired) return;
    card.__planetCardWired = true;

    card.addEventListener('change', (e) => {
      if (e.target.matches('.js-product-card-options input, .product-card__variants input, .variant-option-radio-input, input[name="id"]')) {
        setTimeout(() => scheduleApply(card), 0);
      }
    });

    card.addEventListener('click', (e) => {
      if (e.target.closest('.product-card__variants label, .button--variant, .product-option__label')) {
        setTimeout(() => scheduleApply(card), 0);
      }
    });

    (function waitPlanet(t=0){
      if (typeof window.PlanetDataset?.getDiscountForVariant === 'function') scheduleApply(card);
      else if (t < 120) setTimeout(() => waitPlanet(t+1), 300);
    })();
  }

  function initCards(){
    $$(SEL_CARD).forEach(wireCard);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initCards);
  else initCards();

  const mo = new MutationObserver(muts => {
    muts.forEach(m => {
      m.addedNodes && m.addedNodes.forEach(node => {
        if (!(node instanceof Element)) return;
        if (node.matches?.(SEL_CARD)) wireCard(node);
        node.querySelectorAll?.(SEL_CARD).forEach(wireCard);
      });
    });
  });
  mo.observe(document.body, { childList: true, subtree: true });
})();